module.exports = __webpack_public_path__ + "static/media/top.28352e90.svg";